
export default function ProcessSection() {
  const steps = [
    {
      number: '',
      title: 'Mapeamento do ICP',
      description: 'Identificamos e definimos o Perfil de Cliente Ideal específico para seu negócio.',
      icon: 'ri-map-pin-line',
      features: ['Análise de mercado', 'Segmentação avançada', 'Definição de personas'],
      color: 'from-blue-500 to-cyan-500'
    },
    {
      number: '',
      title: 'Mineração de Dados',
      description: 'Coletamos e validamos dados relevantes usando IA para garantir qualidade máxima.',
      icon: 'ri-database-2-line',
      features: ['Big Data Analytics', 'Validação automática', 'Enriquecimento de dados'],
      color: 'from-purple-500 to-pink-500'
    },
    {
      number: '',
      title: 'Prospecção Inteligente',
      description: 'Executamos campanhas omnichannel com IA generativa e automação avançada.',
      icon: 'ri-rocket-line',
      features: ['Voice AI', 'LinkedIn automation', 'Email sequences', 'WhatsApp IA'],
      color: 'from-green-500 to-emerald-5',
    },
    {
      number: '',
      title: 'Qualificação com IA',
      description: 'Nossa IA qualifica leads automaticamente identificando as melhores oportunidades.',
      icon: 'ri-search-eye-line',
      features: ['Scoring automático', 'Análise comportamental', 'Priorização inteligente'],
      color: 'from-orange-500 to-red-500'
    },
    {
      number: '',
      title: 'Agendamento',
      description: 'Agendamos reuniões qualificadas diretamente na agenda do seu time comercial.',
      icon: 'ri-calendar-check-line',
      features: ['Integração com calendários', 'Confirmação automática', 'Lembretes inteligentes'],
      color: 'from-indigo-500 to-blue-500'
    },
    {
      number: '',
      title: 'Análise e Insights',
      description: 'Fornecemos relatórios detalhados e insights acionáveis sobre todo o processo.',
      icon: 'ri-bar-chart-box-line',
      features: ['Dashboard em tempo real', 'Análise preditiva', 'ROI detalhado'],
      color: 'from-teal-500 to-cyan-500'
    }
  ];

  return (
    <section id="process" className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Nosso Processo
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Metodologia comprovada que transforma sua prospecção em uma máquina de vendas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-2xl p-6 hover:bg-gray-800/70 transition-all duration-300 hover:scale-105 hover:shadow-2xl group h-full flex flex-col"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className={`w-12 h-12 bg-gradient-to-r ${step.color} rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                  <i className={`${step.icon} text-lg text-white`}></i>
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-2">
                    <h3 className="text-lg font-bold text-white group-hover:text-blue-400 transition-colors leading-tight">{step.title}</h3>
                    <span className="text-sm font-bold text-gray-500 group-hover:text-gray-400 transition-colors">
                      {step.number}
                    </span>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed">{step.description}</p>
                </div>
              </div>
              
              <div className="mt-auto">
                <ul className="space-y-1.5">
                  {step.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-xs text-gray-300">
                      <i className="ri-check-line text-green-400 mr-2 flex-shrink-0 text-sm"></i>
                      <span className="leading-tight">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Process Flow Visualization */}
        <div className="mt-20 text-center">
          <h3 className="text-2xl font-bold text-white mb-8">Fluxo do Processo</h3>
          <div className="flex flex-wrap justify-center items-center gap-8 opacity-60">
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-map-pin-line text-2xl"></i>
              <span>Mapeamento</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-database-2-line text-2xl"></i>
              <span>Mineração</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-rocket-line text-2xl"></i>
              <span>Prospecção</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-search-eye-line text-2xl"></i>
              <span>Qualificação</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-calendar-check-line text-2xl"></i>
              <span>Agendamento</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-400">
              <i className="ri-bar-chart-box-line text-2xl"></i>
              <span>Análise</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
